const PdfMessage = ({ message }) => {
  return (
    <div>
      <div className="max-w-full rounded-lg">
        <iframe
          src={message?.media?.file}
          className="h-64"
          title="PDF Preview"
        />
      </div>

      {message?.message && (
        <div className="mt-2 text-sm">{message.message}</div>
      )}
    </div>
  );
};

export default PdfMessage;
